import React from 'react';

import { Box, Stack } from '@mui/material';

import PaginationButtons from './PaginationButtons';
import PaginationCount from './PaginationCount';

type Props = {
  setPage: (v: number) => void;
  currentPage?: number;
  limit?: number;
  count?: number;
  actions?: JsxNode;
};

export default function Pagination({ setPage, currentPage, limit, count, actions }: Props) {
  return (
    <Stack direction="row" alignItems="center" flexShrink={0} spacing={3}>
      {actions}
      <Stack direction="row" alignItems="center" spacing={0}>
        <Box sx={{ display: { xs: 0.5, sm: 'flex' } }}>
          <PaginationCount currentPage={currentPage} limit={limit} count={count} />{' '}
        </Box>
        <PaginationButtons setPage={setPage} currentPage={currentPage} limit={limit} count={count} />
      </Stack>
    </Stack>
  );
}
